type MeteorGlobals = typeof globalThis & {
	Meteor?: object
	Package?: {
		mongo?: {Mongo?: object}
		tracker?: {Tracker?: object}
	}
}

const isMeteorRuntimeReady = (): boolean => {
	const g = globalThis as MeteorGlobals
	return Boolean(g.Meteor && g.Package?.mongo?.Mongo && g.Package?.tracker?.Tracker)
}

/** Poll until Meteor's classic package globals are set by /packages/*.js scripts. */
export const waitForMeteorRuntime = (timeoutMs = 8_000): Promise<void> =>
	new Promise((resolve, reject) => {
		if (isMeteorRuntimeReady()) {
			resolve()
			return
		}

		const deadline = Date.now() + timeoutMs
		const tick = () => {
			if (isMeteorRuntimeReady()) {
				resolve()
				return
			}
			if (Date.now() >= deadline) {
				reject(new Error('Meteor runtime failed to load (network error on /packages/*.js)'))
				return
			}
			window.setTimeout(tick, 50)
		}
		tick()
	})

/** Clear one-shot auto-reload flag after a successful boot. */
export const clearMeteorBootReloadFlag = (): void => {
	try {
		sessionStorage.removeItem('drippy-meteor-reload')
	} catch {
		// sessionStorage may be unavailable in restricted embed contexts
	}
}
